export function createPatchDocument(fieldValues) {
  let patchDoc = [];
  fieldValues.forEach(fv => {
    patchDoc.push({
      op: 'add',
      path: fv.fieldProperty?.replaceAll('.', '/') || fv.fieldName?.replaceAll('.', '/'),
      value: fv.value,
    });
  });

  return patchDoc;
}
